export default "__VITE_ASSET__D8sctSQA__"